import { render, staticRenderFns } from "./ResourceLibrary.vue?vue&type=template&id=91e3c45a&scoped=true"
import script from "./ResourceLibrary.vue?vue&type=script&lang=js"
export * from "./ResourceLibrary.vue?vue&type=script&lang=js"
import style0 from "./ResourceLibrary.vue?vue&type=style&index=0&id=91e3c45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e3c45a",
  null
  
)

export default component.exports